var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBriefing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14286 1.25V2.5H2.32143C1.31585 2.5 0.5 3.33984 0.5 4.375V6.25H17.5V4.375C17.5 3.33984 16.6842 2.5 15.6786 2.5H13.8571V1.25C13.8571 0.558594 13.3145 0 12.6429 0C11.9712 0 11.4286 0.558594 11.4286 1.25V2.5H6.57143V1.25C6.57143 0.558594 6.02879 0 5.35714 0C4.68549 0 4.14286 0.558594 4.14286 1.25ZM17.5 7.5H0.5V18.125C0.5 19.1602 1.31585 20 2.32143 20H15.6786C16.6842 20 17.5 19.1602 17.5 18.125V7.5Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefing);
export default __webpack_public_path__ + "static/media/icon-briefing.c0035955fa95a04b2a507a379033a057.svg";
export { ForwardRef as ReactComponent };